// extracted by mini-css-extract-plugin
module.exports = {"ul":"BulletedList_ul__9tzYn","li":"BulletedList_li__361p2"};